import React from 'react';

import { TableCell, TableRow } from './table';

interface TableSkeletonRowProps {
    columns: number;
}

export const TableSkeletonRow: React.FC<TableSkeletonRowProps> = ({ columns }) => {
    const skeletonWidths = ['w-20', 'w-48', 'w-24', 'w-20', 'w-16', 'w-32', 'w-28'];

    return (
        <TableRow>
            {Array.from({ length: columns }, (_, i) => (
                <TableCell key={i}>
                    <div
                        className={`h-4 animate-pulse rounded bg-gray-200 ${skeletonWidths[i % skeletonWidths.length]}`}
                    />
                </TableCell>
            ))}
        </TableRow>
    );
};
